import Big from 'big.js';
import axios from 'smg/axios';
import { SessionResp } from 'smg/customer-api/session';
import { UserDetails } from 'smg/customer-api/users';
import { HandleRequestError } from 'smg/errors';
import Modal from 'smg/modal';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { DollarFormat } from 'smg/util';
import * as payments from './payments';

export function PrepayModal(amt: Big, sess: SessionResp | undefined = undefined, qrptID: string): Promise<void> {
    const body = template.Clone('#modal-quote-payment-template') as HTMLElement;
    const $prepayModal = new Modal({
        body,
        title: 'Pre-pay & Skip the Line!',
        cancelButton: false,
        close: false,
    });
    const $cancel = document.querySelector('#cancel-btn') as HTMLButtonElement;
    $cancel.addEventListener('click', () => {
        $prepayModal.Close();
    });
    const $pay = document.querySelector('#pay-deposit-btn') as HTMLButtonElement;
    return new Promise(resolve => {
        $pay.addEventListener('click', async () => {
            $prepayModal.Close();
            const sessUser: UserDetails = {
                'email': sess?.email ?? '',
                'firstName': sess?.firstName,
                'lastName': sess?.lastName,
                'company': sess?.company,
                'phone': sess?.phone ?? '',
            };
            const paymentOption = await payments.PromptPaymentOption(sess, undefined, [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT]);

            const body = template.Clone('#modal-quote-deposit-payment');

            void payments.DrawPaymentOption(paymentOption).then(card => {
                body.querySelector('#modal-payment-option')?.replaceWith(card);
                (body.querySelector('#modal-balance-amount') as HTMLElement).textContent = DollarFormat(amt);

                const $confirmPayment = new Modal({
                    title: 'Confirm Payment',
                    size: 'modal-sm',
                    outsideClosable: false,
                    confirmText: 'Confirm Payment',
                    confirmButtonClass: 'btn btn-secondary text-white order-1 flex-grow-1 flex-md-grow-0',
                    cancelButtonClass: 'btn btn-outline-secondary text-secondary order-2 flex-grow-1 flex-md-grow-0',
                    closeButtonClass: 'btn-close d-none',
                    buttons: [
                        {
                            text: 'Back',
                            class: 'btn btn-outline-secondary text-secondary me-md-auto flex-grow-1 flex-md-grow-0',
                            click: async () => {
                                $confirmPayment.Close();
                                await PrepayModal(amt, sess, qrptID);
                            },
                        },
                    ],
                    body,
                    onSubmit: () => axios.post(`/quote-request-project-tasks/${qrptID}/prepay`, {
                        'paymentOptionID': paymentOption.key,
                        'amount': amt.round(2)?.toString(),
                        'user': sessUser,
                    }).then(() => {
                        toast.Success('Your payment has been received.');
                        resolve();
                    }).catch(HandleRequestError),
                });
            });
        });
    });
}